/**
 * Hook: useMenuConfig
 *
 * O menu que a pessoa alcança, tal como o manifesto o entregou — T21 e T24 da spec #408.
 *
 * O servidor já filtrou por permissão e já aplicou a perspectiva na ordem e no rótulo, então
 * aqui não se reordena nem se refiltra por perspectiva: se ela conseguisse esconder um item
 * neste arquivo, teria virado papel hardcoded com nome novo. O único corte que sobra é o do
 * módulo comercial, e ele é daqui porque o manifesto entrega permissões e módulos separados.
 */

import { useMemo } from 'react';

import { useManifesto } from '../stores/manifestoStore';
import { ProcessedMenuGroup, ProcessedMenuItem } from '../types/menuConfig';
import { moduloDisponivel } from '../utils/manifestoMenu';

export function useMenuConfig(): ProcessedMenuGroup[] {
  const { manifesto } = useManifesto();

  return useMemo(() => {
    if (!manifesto) return [];

    const grupos: ProcessedMenuGroup[] = [];

    for (const grupo of manifesto.menu) {
      const disponiveis = grupo.itens.filter((item) =>
        moduloDisponivel(item, manifesto.modulos)
      );
      if (disponiveis.length === 0) continue;

      const items: ProcessedMenuItem[] = [];
      let blocoAnterior: number | undefined;

      for (const item of disponiveis) {
        items.push({
          id: item.id,
          label: item.rotulo,
          iconName: item.icone,
          path: item.caminho,
          disabled: item.desabilitado,
          dividerBefore:
            blocoAnterior !== undefined &&
            item.separador !== undefined &&
            item.separador !== blocoAnterior,
        });

        blocoAnterior = item.separador;
      }

      grupos.push({
        id: grupo.id,
        label: grupo.rotulo,
        iconName: grupo.icone,
        items,
        density: disponiveis.length / grupo.itens.length,
      });
    }

    return grupos;
  }, [manifesto]);
}

export default useMenuConfig;
